import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useView } from '@hooks';
import { useStore } from '@stores';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

/**
 * Shows or hides the order's header cards from the drawer / page header, so the body does not
 * spend a row on the toggle. On a phone the cards are a collapse of their own, so nothing to do.
 */
export const OrderDetailsToggle: React.FC = observer(() => {
  const { isMobile } = useView();
  const { orderStore } = useStore();
  const { orderDetailsExpanded, toggleOrderDetails } = orderStore;

  if (isMobile) return null;

  return (
    <Button
      type="text"
      size="small"
      icon={orderDetailsExpanded ? <UpOutlined /> : <DownOutlined />}
      onClick={toggleOrderDetails}
      style={{ color: 'rgba(0, 0, 0, 0.65)' }}
    >
      {orderDetailsExpanded ? 'Hide details' : 'Show details'}
    </Button>
  );
});
